import { createFileRoute, redirect } from "@tanstack/react-router";
import { EVENT_ATTRIBUTES } from "@/features/clinical-access/constants";

const ALLOWED = new Set<string>(EVENT_ATTRIBUTES);

export const Route = createFileRoute("/_app/admin/access/$attribute")({
    beforeLoad: ({ params }) => {
        if (!ALLOWED.has(params.attribute)) {
            throw redirect({ to: "/admin/access/users", replace: true });
        }
    },
    component: () => null,
});
